import React, { useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { FormInputNew } from 'components/Input/FormInputNew';

interface IProps {
	changeEmail: (value: string) => void;
}

export const EmailField: React.FC<IProps> = React.memo(({ changeEmail }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [
			{ required: true, message: t('enterEmail') },
			{
				type: 'email',
				message: t('invalidEmail'),
			},
		],
		[t],
	);

	return (
		<FormInputNew
			testId="EmailField"
			name="email"
			label="emailLabel"
			validationRules={validationRules}
			onChange={changeEmail}
		/>
	);
});
